import { render } from "./HowToUseSection.vue?vue&type=template&id=44aa38eb&scoped=true"
import script from "./HowToUseSection.vue?vue&type=script&lang=js"
export * from "./HowToUseSection.vue?vue&type=script&lang=js"

import "./HowToUseSection.vue?vue&type=style&index=0&id=44aa38eb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44aa38eb"]])

export default __exports__